module.exports = __webpack_public_path__ + "static/brenda-small-b1d2948de10bdf66dcba5c651e2c066c.webp";